function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getAdditionalProps, datePropType } from '../utils/propTypes';
import RangePickerController from './_internal/RangePickerController';
import * as constants from './constants';

var InlineDateRangePicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InlineDateRangePicker, _PureComponent);

  function InlineDateRangePicker(props) {
    var _this;

    _classCallCheck(this, InlineDateRangePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InlineDateRangePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_handleFocus", function (focusedInput) {
      var onFocus = _this.props.onFocus;
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;
      var newFocusedInput = focusedInput ? focusedInput : 'startDate';

      _this.setState({
        focusedInput: newFocusedInput
      }, function () {
        if (onFocus) {
          onFocus({
            startDate: startDate,
            endDate: endDate,
            focusedInput: focusedInput
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDatesChange", function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var onChange = _this.props.onChange;

      _this.setState({
        startDate: startDate,
        endDate: endDate
      }, function () {
        if (onChange) {
          onChange({
            startDate: startDate,
            endDate: endDate
          });
        }
      });
    });

    var initialFocusedInput = props.initialFocusedInput,
        defaultValue = props.defaultValue,
        value = props.value;
    var _startDate = null;
    var _endDate = null;

    if (defaultValue) {
      _startDate = defaultValue.startDate;
      _endDate = defaultValue.endDate;
    }

    if (value) {
      _startDate = value.startDate;
      _endDate = value.endDate;
    }

    _this.state = {
      startDate: _startDate,
      endDate: _endDate,
      focusedInput: initialFocusedInput
    };
    return _this;
  }

  _createClass(InlineDateRangePicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var _ref2$value = _ref2.value,
          value = _ref2$value === void 0 ? {} : _ref2$value;
      this.setState(function (_ref3) {
        var startDate = _ref3.startDate,
            endDate = _ref3.endDate;
        var newStartDate = value.startDate,
            newEndDate = value.endDate;
        var startDateToReturn = startDate;
        var endDateToReturn = endDate;

        if (newStartDate && newStartDate !== startDate) {
          startDateToReturn = newStartDate;
        }

        if (newEndDate && newEndDate !== endDate) {
          endDateToReturn = newEndDate;
        }

        return {
          startDate: startDateToReturn,
          endDate: endDateToReturn
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      var _this$state2 = this.state,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate,
          focusedInput = _this$state2.focusedInput;
      var classes = classNames('eds-date-picker', 'eds-date-picker--inline', 'eds-date-picker--range', "eds-date-picker--".concat(color));
      var extraAttrs = getAdditionalProps(this);
      return React.createElement("div", {
        className: classes
      }, React.createElement(RangePickerController, _extends({}, extraAttrs, {
        onFocusChange: this._handleFocus,
        onDatesChange: this._handleDatesChange,
        focusedInput: focusedInput,
        startDate: startDate,
        endDate: endDate,
        minDate: minDate,
        maxDate: maxDate,
        hasDropDown: false
      })));
    }
  }]);

  return InlineDateRangePicker;
}(PureComponent);

_defineProperty(InlineDateRangePicker, "propTypes", {
  /**
   * Initial date
   */
  defaultValue: PropTypes.shape(constants.RANGE_VALUE),

  /**
   * Current selected date
   */
  value: PropTypes.shape(constants.RANGE_VALUE),

  /**
   * Calendar color scheme
   */
  color: PropTypes.oneOf(constants.COLOR_PROP),

  /**
   * Minimum date that can be chosen
   */
  minDate: datePropType,

  /**
   * Maximum date that can be chosen
   */
  maxDate: datePropType,

  /**
   * Set error state
   */
  hasError: PropTypes.bool,

  /**
   * {function} for handling date selection
   */
  onChange: PropTypes.func,

  /**
   * {function} onFocus
   */
  onFocus: PropTypes.func,

  /**
   * The calendar should open focused on the passed in option.
   * Available options: startDate, endDate
   */
  initialFocusedInput: PropTypes.oneOf(constants.INITIAL_FOCUS)
});

_defineProperty(InlineDateRangePicker, "defaultProps", {
  color: constants.BLUE_COLOR
});

export { InlineDateRangePicker as default };